<template>
    <div>
        <h1 style="font-size: 24px; color: black;">应用基础管理</h1>
        <el-card class="form-container" shadow="never">
            <el-row type="flex" align="middle">
                <el-col :span="4">
                    <span> 部门：</span>
                    <el-select v-model="queryData.dept" placeholder="请选择">
                        <el-option :key="-1" label="全部" :value="-1"></el-option>
                        <el-option v-for="(value,key) in deptObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <span> 状态：</span>
                    <el-select v-model="queryData.state" placeholder="请选择">
                        <el-option :key="-1" label="全部" :value="-1"></el-option>
                        <el-option v-for="(value,key) in states"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-col>
                <el-button type="primary" @click="query">查询</el-button>
                <el-button class="sub-sub" type="primary" @click="showDetails('新增应用')">新增</el-button>
            </el-row>

        </el-card>
        <h1>
            <el-table :data="appList"
                      border
                      :fit="true">
                <el-table-column label="应用ID" prop="appId" align="center"></el-table-column>
                <el-table-column label="应用名称" prop="appName" align="center"></el-table-column>
                <el-table-column label="包名" prop="packageName" align="center"></el-table-column>
                <el-table-column label="密钥" prop="secretKey" align="center"></el-table-column>
                <el-table-column label="版本" prop="systemVersion" align="center"></el-table-column>
                <el-table-column label="类型" prop="type" align="center"></el-table-column>
                <el-table-column label="所属项目组" prop="dept" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.dept | commonFilter(deptObj) }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="state" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.state | commonFilter(states) }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑应用',scope.row)">编辑
                        </el-button>
                        <el-button plain size="mini" type="danger" @click="remove(scope.row.appId)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </h1>
        <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
            <el-form :model="addAppForm">
                <el-form-item label="应用名称 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addAppForm.appName" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="包名 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addAppForm.packageName" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="密钥 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addAppForm.secretKey" maxlength="50" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="版本 :" :label-width="labelWidth">
                    <el-select v-model="addAppForm.systemVersion">
                        <el-option value="android">android</el-option>
                        <el-option value="ios">ios</el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型 :" :label-width="labelWidth">
                    <el-input type="text" v-model="addAppForm.type"></el-input>
                </el-form-item>
                <el-form-item label="部门 :" :label-width="labelWidth">
                    <el-select v-model="addAppForm.dept" placeholder="请选择">
                        <el-option v-for="(value,key) in deptObj"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态 :" :label-width="labelWidth">
                    <el-select v-model="addAppForm.state" placeholder="请选择">
                        <el-option v-for="(value,key) in states"
                                   :key="Number(key)"
                                   :label="value"
                                   :value="Number(key)"></el-option>
                    </el-select>
                </el-form-item>
                <div style="text-align: center;">
                    <el-button type="primary" @click="confirmForm">提 交</el-button>
                    <el-button type="info" @click="dialogVisible=false">取 消</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[10,20,30]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="page.totalElements">
        </el-pagination>
    </div>
</template>

<script>
import {deleteApp, saveApp, searchApp} from "@/http/settingApi";
import {states} from '@/constants/common/basic-data'
import settingMix from '@/utils/mix/common-setting'

export default {
    name: "AppList",
    mixins: [settingMix],
    data() {
        return {
            dialogVisible: false,
            dialogTitle: '',
            appList: [],
            labelWidth: '110px',
            addAppForm: {
                appId: 0,
                appName: '',
                packageName: '',
                secretKey: '',
                systemVersion: '',
                type: '',
                dept: 1,
                state: 1
            },
            needDept: true,
            deptObj: {},
            states: states,
            queryData: {
                dept: -1,
                state: -1,
                order: 'descending',
                prop: 'app_id'
            },
            page: {
                size: 10,
                page: 1,
                totalElements: null
            },
        }
    },
    methods: {
        showDetails(title, data) {
            if (data) {
                this.addAppForm = {
                    appId: data.appId,
                    appName: data.appName,
                    packageName: data.packageName,
                    secretKey: data.secretKey,
                    systemVersion: data.systemVersion,
                    type: data.type,
                    dept: Number(data.dept),
                    state: data.state
                }
            } else {
                this.addAppForm = {
                    appId: 0,
                    appName: '',
                    packageName: '',
                    secretKey: '',
                    systemVersion: '',
                    type: '',
                    dept: 1,
                    state: 1
                }
            }
            this.dialogTitle = title;
            this.dialogVisible = true;
        },
        remove(id) {
            console.log("删除：" + id)
            this.$confirm('此操作将删除应用, 是否继续?', '提示', {
                cancelButtonClass: 'btn-custom-cancel',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteApp(id).then(resp => {
                    if (resp.data.status === 0) {
                        this.query();
                    }
                });
            }).catch(() => {
            })
        },
        confirmForm() {
            let _message = '';
            if (this.addAppForm.appName === '') {
                _message = '请输入应用名称'
            } else if (this.addAppForm.packageName === '') {
                _message = '请输入包名'
            } else if (this.addAppForm.secretKey === '') {
                _message = '请输入秘钥'
            } else if (this.addAppForm.dept === '') {
                _message = '请勾选部门'
            }
            if (_message) {
                this.$message({
                    message: _message,
                    type: 'error'
                });
                return;
            }
            saveApp(this.addAppForm).then(resp => {
                if (resp.data.status === 0) {
                    this.query();
                    this.dialogVisible = false;
                }
            });
        },
        handleSizeChange(size) {
            this.page.size = size;
            this.query();
        },
        handleCurrentChange(page) {
            this.page.page = page;
            this.query();
        },
        query() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            searchApp(this.queryData).then(resp => {
                this.appList = resp.data.info.content;
                this.page.totalElements = resp.data.info.totalElements
            })
        },
    },
    created() {
        this.query();
        // this.deptList()
    }
}
</script>

<style scoped>

</style>
